import React, { useEffect, useMemo, useState } from 'react'
import MediaBanner from './MediaBanner'
import MediaFilter from './MediaFilter'
import MediaGrid from './MediaGrid'
import { BaseUrl } from '../../../helper/BaseUrl'
import { fetchJson } from '../../../helper/fetchJson'

export default function MediaListing({ initialData }) {

  const bannerData = {
    head: "Home",
    breadcrumb: [
      {
        slug: "",
        name: "Media"
      }
    ]
  }

  const [activeTab, setActiveTab] = useState("All");
  const [data, setData] = useState(Array.isArray(initialData) ? initialData : []);

  useEffect(() => {
    if (Array.isArray(initialData)) return undefined;
    let active = true;
    fetchJson(`${BaseUrl}/api/news?status=active`)
      .then((response) => {
        if (active) setData(response?.news || []);
      })
      .catch((error) => console.error("Unable to fetch media:", error.message));
    return () => {
      active = false;
    };
  }, [initialData]);

  const categories = useMemo(
    () => [...new Set(data.map((item) => item.media_category_name).filter(Boolean))],
    [data]
  );

  const filteredData = useMemo(
    () => activeTab === "All"
      ? data
      : data.filter((item) => item.media_category_name === activeTab),
    [activeTab, data]
  );



  return (
    <>
      <MediaBanner breadcrumb={bannerData.breadcrumb} />
      <MediaFilter activeTab={activeTab}
        setActiveTab={setActiveTab}
        categories={categories}
        total={filteredData.length} />
      <MediaGrid data={filteredData} />

    </>
  )
}
